module.exports = __webpack_public_path__ + "static/media/2.19d4bd6c.jpg";